var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es.array.reduce.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParseNewLines = exports.replaceNewlines = void 0;

var react_1 = __importDefault(require("react"));

var any_1 = require("../elements/any");

exports.replaceNewlines = function (children) {
  var result = [];
  react_1.default.Children.forEach(children, function (child) {
    if (child && typeof child === 'string') {
      result.push(child.split('\n').reduce(function (children, textSegment, index) {
        return [].concat(_toConsumableArray(children), [index > 0 && react_1.default.createElement("br", {
          key: index
        }), textSegment]);
      }, []));
    } else if (child) {
      result.push(child);
    }
  });
  return result;
};

exports.ParseNewLines = function (props) {
  return react_1.default.createElement(any_1.Any, {
    is: props.is,
    polyPreset: true,
    wheel: props.wheel
  }, exports.replaceNewlines(props.children));
};